// tslint:disable
import { Injector, Component } from "@angular/core";

import {
  CMFormBrowse2Component,
  CMFormPesquisaComponent,
} from "./../../@cmcore/component";
import { GrupoDeProdutoEditComponent } from "./grupodeproduto-edit.component";

@Component({
  selector: "grupodeproduto-browse",
  templateUrl:
    "./../../@cmcore/component/cmform/cmform-browse/cmform-browse2.component.html",
  styleUrls: [
    "./../../@cmcore/component/cmform/cmform-browse/cmform-browse2.component.scss",
  ],
})
export class GrupoDeProdutoBrowseComponent extends CMFormBrowse2Component {
  static defaultColumns = [
    { field: "codigo", caption: "Código", width: "100" },
    { field: "descricao", caption: "Descrição", filter: true },
  ];

  constructor(_injector: Injector) {
    super(_injector);
    this.controllerName = "grupodeproduto";
    this.fixedFooterFormEdit = false;
    this.formEditComponent = GrupoDeProdutoEditComponent;
    this.columns = GrupoDeProdutoBrowseComponent.defaultColumns;
  }

  getTitle() {
    return "Grupo de Produto";
  }

  static pesquisa(sender: any, target: any, targetProp: any = undefined) {
    if (target) {
      CMFormPesquisaComponent.defaultPesquisa(
        sender,
        "grupodeproduto",
        "Pesquisa de Grupo de Produto",
        GrupoDeProdutoBrowseComponent.defaultColumns,
        target,
        targetProp,
        "codigo",
        undefined,
        false
      );
    }
  }
}
